import React from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import styles from './styles.module.scss';

type Props = {
  title: string;
  subtitle?: string;
};

const HeroTitle: React.FC<Props> = ({ title, subtitle }) => {
  // 背景アニメーション用のフック（複数の背景要素用）
  const { ref: bg0Ref, isVisible: isBg0Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg1Ref, isVisible: isBg1Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg2Ref, isVisible: isBg2Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg3Ref, isVisible: isBg3Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg4Ref, isVisible: isBg4Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });
  const { ref: bg5Ref, isVisible: isBg5Visible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section className={styles.hero}>
      <div className={styles.hero__bg}>
        <div
          ref={bg0Ref}
          className={`${styles.hero__bg__0} ${isBg0Visible ? styles['hero__bg__0--visible'] : ''}`}
        >
          <svg
            width="103"
            height="103"
            viewBox="0 0 103 103"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="51.5"
              cy="51.5"
              r="49.5768"
              stroke="#F1ECE6"
              strokeWidth="3.84647"
              strokeDasharray="7.69 7.69"
            />
          </svg>
        </div>
        <div
          ref={bg1Ref}
          className={`${styles.hero__bg__1} ${isBg1Visible ? styles['hero__bg__1--visible'] : ''}`}
        >
          <svg
            width="168"
            height="91"
            viewBox="0 0 168 91"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              y="86.3947"
              width="152.577"
              height="4.87832"
              rx="2.43916"
              transform="rotate(-29.7401 0 86.3947)"
              fill="#F6B8DF"
            />
            <rect
              x="50"
              y="76.3947"
              width="152.577"
              height="4.87832"
              rx="2.43916"
              transform="rotate(-29.7401 50 76.3947)"
              fill="#F6B8DF"
            />
          </svg>
        </div>
        <div
          ref={bg2Ref}
          className={`${styles.hero__bg__2} ${isBg2Visible ? styles['hero__bg__2--visible'] : ''}`}
        >
          <svg
            width="161"
            height="102"
            viewBox="0 0 161 102"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="152.513" cy="7.51302" r="7.51302" fill="#F6B8DF" />
            <rect
              y="85.6887"
              width="152.577"
              height="18.2606"
              rx="9.1303"
              transform="rotate(-29.7401 0 85.6887)"
              fill="url(#paint0_linear_5426_280)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5426_280"
                x1="0"
                y1="94.819"
                x2="152.577"
                y2="94.819"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#3F78FB" />
                <stop offset="1" stopColor="#F6B8DF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg3Ref}
          className={`${styles.hero__bg__3} ${isBg3Visible ? styles['hero__bg__3--visible'] : ''}`}
        >
          <svg
            width="180"
            height="119"
            viewBox="0 0 180 119"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="15.5" cy="103.206" r="15.5" fill="#9997ED" />
            <rect
              x="31.3125"
              y="75.6886"
              width="152.577"
              height="31.7423"
              rx="15.8711"
              transform="rotate(-29.7401 31.3125 75.6886)"
              fill="url(#paint0_linear_5426_288)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_5426_288"
                x1="31.3125"
                y1="91.5598"
                x2="183.89"
                y2="91.5598"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#9D99ED" />
                <stop offset="1" stopColor="#124EF3" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div
          ref={bg4Ref}
          className={`${styles.hero__bg__4} ${isBg4Visible ? styles['hero__bg__4--visible'] : ''}`}
        >
          <svg
            width="46"
            height="45"
            viewBox="0 0 46 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.8282 0.844334C24.8827 0.730216 25.0511 0.752405 25.0741 0.876783L28.0068 16.7237C28.0774 17.1055 28.3861 17.3983 28.771 17.4491L44.7477 19.5572C44.8731 19.5738 44.9044 19.7412 44.7933 19.8016L30.6281 27.4873C30.2869 27.6724 30.1032 28.0563 30.1737 28.4379L33.1063 44.2849C33.1293 44.4093 32.9794 44.4909 32.8877 44.4038L21.2008 33.307C20.9193 33.0397 20.4974 32.984 20.1562 33.1691L5.99095 40.8548C5.87984 40.9147 5.7572 40.7974 5.81164 40.6834L12.7534 26.1394C12.9205 25.789 12.8436 25.3708 12.562 25.1035L0.875159 14.0066C0.783519 13.9196 0.856437 13.7662 0.981592 13.7823L16.9593 15.8905C17.3442 15.9413 17.7183 15.7386 17.8855 15.3883L24.8282 0.844334Z"
              fill="white"
              stroke="#1549B6"
              strokeWidth="0.765608"
            />
          </svg>
        </div>
        <div
          ref={bg5Ref}
          className={`${styles.hero__bg__5} ${isBg5Visible ? styles['hero__bg__5--visible'] : ''}`}
        >
          <svg
            width="61"
            height="64"
            viewBox="0 0 61 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.3576 1.17838C22.3548 1.00231 22.5784 0.925413 22.6845 1.06592L36.2016 19.013C36.5272 19.4454 37.0944 19.6188 37.6062 19.4427L58.8519 12.1336C59.0185 12.0766 59.1607 12.2658 59.0596 12.4102L46.168 30.812C45.8577 31.2552 45.8674 31.848 46.1929 32.2802L59.71 50.2273C59.816 50.3682 59.6797 50.5622 59.511 50.5106L38.0269 43.936C37.5094 43.7777 36.9486 43.9706 36.638 44.4138L23.7461 62.8147C23.6449 62.9591 23.4181 62.8901 23.415 62.7138L23.0293 40.2492C23.0199 39.7081 22.6629 39.2349 22.1456 39.0764L0.661076 32.5009C0.49266 32.4493 0.488313 32.2127 0.654669 32.1551L21.9003 24.846C22.4122 24.6699 22.7526 24.1842 22.7433 23.643L22.3576 1.17838Z"
              fill="white"
              stroke="#1549B6"
              strokeWidth="1.06735"
            />
          </svg>
        </div>
      </div>

      <div className={styles.hero__container}>
        <h1 className={styles.hero__title}>
          <strong>{title}</strong>
          {subtitle && <span>{subtitle}</span>}
        </h1>
      </div>
    </section>
  );
};

export default HeroTitle;
